import React from 'react';

import Accordion from 'xgimi-ui/mui/material/Accordion';
import AccordionSummary from 'xgimi-ui/mui/material/AccordionSummary';
import AccordionDetails from 'xgimi-ui/mui/material/AccordionDetails';
import Icon, { icons } from 'xgimi-ui/Icon';
import Base from 'xgimi-ui/BaseComponent';

import s from './.module.scss';

interface Props {
  // 是否默认展开
  isDefaultExpand?: boolean;
  // 标题
  title: string;
}

interface State {
  // 是否展开
  isExpand: boolean;
}

/**
 * 展开面板
 */
export default class extends Base<Props, State> {
  static defaultProps = {

  };

  state: State = {
    isExpand: !!this.props.isDefaultExpand,
  };

  render(): React.ReactNode {
    return (
      <Accordion
        className={this.getClassName()}
        classes={{ root: s.root }}
        expanded={this.state.isExpand}
        onChange={() => this.setState((preState) => ({ isExpand: !preState.isExpand }))}
        elevation={1}
      >
        <AccordionSummary expandIcon={<Icon type={icons.ExpandMore} />} >
          <span className={s.block} />
          <span className={s.title}>{this.props.title}</span>
        </AccordionSummary>
        <AccordionDetails>
          {this.props.children}
        </AccordionDetails>
      </Accordion>
    );
  }
}
